@if (dashboard.invitations().length > 0) {
  <ct-lib-dashboard-card
    [title]="'jobboard.platform.dashboard.invitations.title' | transloco"
    [icon]="icons.envelope"
    [scrollable]="true"
  >
    <span dashboardCardHeaderActions class="count text-muted">
      {{ dashboard.invitations().length }}
    </span>

    <div class="invitation-list" role="list">
      @for (invitation of dashboard.previewInvitations(); track invitation.id) {
        <app-platform-dashboard-invitation-item
          role="listitem"
          [invitation]="invitation"
        ></app-platform-dashboard-invitation-item>
      }
    </div>

    <a
      dashboardCardFooter
      class="view-all-link"
      [routerLink]="['/jobs']"
      [queryParams]="{ tab: 'invitations' }"
    >
      {{ 'jobboard.platform.dashboard.invitations.view-all' | transloco }}
      <fa-icon [icon]="icons.chevronRight" aria-hidden="true"></fa-icon>
    </a>
  </ct-lib-dashboard-card>
}
